export default __webpack_public_path__ + "static/media/key-step7.dc919ba3.gif";